import { HttpClient } from '@easydata/core';
import { Query } from '../query/query';
import { DataModel } from '../dm/data_model';
import { BrowserQueryStorage } from '../main/query_storage';
import { EqServerModelLoader } from '../eqs/eqs_model_loader';
import { EqServerDataFetcher } from '../eqs/eqs_data_fetcher';
import { EqServerQuerySynchronizer } from '../eqs/eqs_query_synchronizer';
import { EqServerValueListResolver } from '../eqs/eqs_value_list_resolver';
import { EqQueryFileLoader } from '../eqs/eqs_query_file_loader';
import { DefaultAggregatesCalculator } from '../data/eq_aggr_container';
var EqServiceProvider = /** @class */ (function () {
    function EqServiceProvider(context) {
        this.context = context;
        this.modelLoader = null;
        this.queryStorage = null;
        this.querySynchronizer = null;
        this.dataFetcher = null;
        this.valueListResolver = null;
        this.queryFileLoader = null;
        this.aggrCalculator = null;
        this.httpClient = new HttpClient();
        this.httpClient.defaultHeaders['x-eqjs-version'] = '7.2.0';
        this.modelResolver = function (_) { return new DataModel(); };
        this.modelStorageResolver = null;
        this.queryResolver = function (context) { return new Query(context.getModel()); };
        this.modelLoaderResolver = function (context) { return new EqServerModelLoader(context); };
        this.queryStorageResolver = function (context) { return new BrowserQueryStorage(context); };
        this.querySynchronizerResolver = function (context) { return new EqServerQuerySynchronizer(context); };
        this.vlrResolver = function (context) { return new EqServerValueListResolver(context); };
        this.dataFetcherResolver = function (context) { return new EqServerDataFetcher(context); };
        this.queryFileLoaderResolver = function (context) { return new EqQueryFileLoader(context); };
        this.aggrCalculatoResolver = function (context) { return new DefaultAggregatesCalculator(context); };
    }
    EqServiceProvider.prototype.reset = function () {
        this.modelStorage = null;
        this.modelLoader = null;
        this.queryStorage = null;
        this.querySynchronizer = null;
    };
    EqServiceProvider.prototype.getHttpClient = function () {
        return this.httpClient;
    };
    EqServiceProvider.prototype.createDataModel = function () {
        if (!this.modelResolver) {
            throw 'Model resolver is not defined';
        }
        return this.modelResolver(this.context);
    };
    EqServiceProvider.prototype.createQuery = function () {
        if (!this.queryResolver) {
            throw 'Query resolver is not defined';
        }
        return this.queryResolver(this.context);
    };
    EqServiceProvider.prototype.getModelLoader = function () {
        if (!this.modelLoader) {
            if (!this.modelLoaderResolver) {
                throw 'ModelLoaderResolver is not defined';
            }
            this.modelLoader = this.modelLoaderResolver(this.context);
        }
        return this.modelLoader;
    };
    EqServiceProvider.prototype.getModelStorage = function () {
        if (!this.modelStorage) {
            if (!this.modelStorageResolver) {
                throw 'ModelStorageResolver is not defined';
            }
            this.modelStorage = this.modelStorageResolver(this.context);
        }
        return this.modelStorage;
    };
    EqServiceProvider.prototype.getQueryStorage = function () {
        if (!this.queryStorage) {
            if (!this.queryStorageResolver) {
                throw 'QueryStorageResolver is not defined';
            }
            this.queryStorage = this.queryStorageResolver(this.context);
        }
        return this.queryStorage;
    };
    EqServiceProvider.prototype.getQuerySynchronizer = function () {
        if (!this.querySynchronizer) {
            if (!this.querySynchronizerResolver) {
                throw 'QuerySynchronizerResolver is not defined';
            }
            this.querySynchronizer = this.querySynchronizerResolver(this.context);
        }
        return this.querySynchronizer;
    };
    EqServiceProvider.prototype.getDataFetcher = function () {
        if (!this.dataFetcher) {
            if (!this.dataFetcherResolver) {
                throw 'DataFetcherResolver is not defined';
            }
            this.dataFetcher = this.dataFetcherResolver(this.context);
        }
        return this.dataFetcher;
    };
    EqServiceProvider.prototype.getValueListResolver = function () {
        if (!this.valueListResolver) {
            if (!this.vlrResolver) {
                throw 'Resolver for ValueListResolver is not defined';
            }
            this.valueListResolver = this.vlrResolver(this.context);
        }
        return this.valueListResolver;
    };
    EqServiceProvider.prototype.getQueryFileLoader = function () {
        if (!this.queryFileLoader) {
            if (!this.queryFileLoaderResolver) {
                throw 'Resolver for QueryFileLoader is not defined';
            }
            this.queryFileLoader = this.queryFileLoaderResolver(this.context);
        }
        return this.queryFileLoader;
    };
    EqServiceProvider.prototype.getAggregatesCalculator = function () {
        if (!this.aggrCalculator) {
            if (!this.aggrCalculatoResolver) {
                throw 'Resolver for AggregatesCalculator is not defined';
            }
            this.aggrCalculator = this.aggrCalculatoResolver(this.context);
        }
        return this.aggrCalculator;
    };
    EqServiceProvider.prototype.registerDataModelResolver = function (resolver) {
        this.modelResolver = resolver;
    };
    EqServiceProvider.prototype.registerQueryResolver = function (resolver) {
        this.queryResolver = resolver;
    };
    EqServiceProvider.prototype.registerModelLoaderResolver = function (resolver) {
        this.modelLoaderResolver = resolver;
    };
    EqServiceProvider.prototype.registerModelStorageResolver = function (resolver) {
        this.modelStorageResolver = resolver;
    };
    EqServiceProvider.prototype.registerQueryStorageResolver = function (resolver) {
        this.queryStorageResolver = resolver;
    };
    EqServiceProvider.prototype.registerDataFetcherResolver = function (resolver) {
        this.dataFetcherResolver = resolver;
    };
    EqServiceProvider.prototype.registerQuerySyncronizerResolver = function (resolver) {
        this.querySynchronizerResolver = resolver;
    };
    EqServiceProvider.prototype.registerValueListResolver = function (resolver) {
        this.vlrResolver = resolver;
    };
    EqServiceProvider.prototype.registerQueryFileLoaderResolver = function (resolver) {
        this.queryFileLoaderResolver = resolver;
    };
    EqServiceProvider.prototype.registerAggregatesCalculator = function (resolver) {
        this.aggrCalculatoResolver = resolver;
    };
    return EqServiceProvider;
}());
export { EqServiceProvider };
//# sourceMappingURL=eq_services.js.map